$(function() {
  // Highlight tab based on URL parameter
  var url_params = new URLSearchParams(window.location.search);
  var selected_tab = url_params.get('tab');
  if (selected_tab) {
    $('#myTab a[href="#' + selected_tab + '"]').tab('show');
  }

  // Update URL when tabs are clicked
  // https://stackoverflow.com/questions/10970078/modifying-a-query-string-without-reloading-the-page
  // https://webdesign.tutsplus.com/tutorials/how-to-add-deep-linking-to-the-bootstrap-4-tabs-component--cms-31180
  $('a[data-toggle="tab"]').on('shown.bs.tab', function(e) {
    var anchor_hash = this.hash;
    var tab_name = anchor_hash.replace(/^#/, '');
    if (history.replaceState) {
      var new_url = window.location.protocol + '//' + window.location.host + window.location.pathname + '?tab=' + tab_name;
      window.history.replaceState({
        path: new_url
      }, '', new_url);
    }
  });
});
